<template>
<!--
    street: '',
    neighborhood: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    additionalInfo: '' 
    -->
    <!-- <div id="direccion-envio"> -->
        <b-card id="direccion-envio" :header="header">
            <b-form @submit.prevent="updateAddress">
    
                <b-row inverse>
                    <b-col>
                        <b-form-group label="Estado *" label-for="state">
                            <b-form-select
                                id="state"
                                v-model="address.state"
                                :options="estadosMexico"
                                placeholder="Selecciona un estado"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group label="Ciudad *" label-for="city">
                            <b-form-input
                                id="city"
                                v-model="address.city"
                                placeholder="Ingresa la ciudad"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group label="Colonia *" label-for="neighborhood">
                            <b-form-input
                                id="neighborhood"
                                v-model="address.neighborhood"
                                placeholder="Ingresa la colonia"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
    
                <hr>
    
                <b-row>
                    <b-col>
                        <b-form-group label="Calle y Número *" label-for="street">
                            <b-form-input
                                id="street"
                                v-model="address.street"
                                placeholder="Ingresa la calle y número"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group label="Código Postal *" label-for="postalCode">
                            <b-form-input
                                id="postalCode"
                                v-model="address.postalCode"
                                placeholder="Ingresa el código postal"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
    
                <hr>
    
                <b-form-group label="Información Adicional" label-for="additionalInfo">
                    <b-form-textarea
                        id="additionalInfo"
                        v-model="address.additionalInfo"
                        placeholder="Ingresa información adicional"></b-form-textarea>
                </b-form-group>
    
            </b-form>

            <template v-if="debug">
                <pre class="p-4"><code>direccionEnvio.workAddress: {{ address }}</code></pre>
            </template>


        </b-card>
    <!-- </div> -->
</template>

<script>
import _ from 'lodash';
import direccionEnvio from './direccionEnvioArchetype';

export default {
    name: 'direccionEnvio',
    props: {
        debug: {
            type: Boolean,
            default: false
        },
        header: {
            type: String,
            default: 'Dirección de envío'
        },
        estadosMexico: {
            type: Array,
            default: () => direccionEnvio.estadosMexico
        }
    },

    data() {
        return {
            address: direccionEnvio.workAddress,
        };
    },

    methods: {
        updateAddress() {
            this.$emit('updated', this.address);
        }
    }
}
</script>